import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function NotFound() {
  const { t } = useTranslation("common");

  return (
    <div
      data-testid="not-found-page"
      className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4 text-center"
    >
      <div className="text-center">
        <h1
          data-testid="not-found-heading"
          className="text-6xl font-bold text-primary-300 mb-4"
        >
          404
        </h1>
        <p
          data-testid="not-found-message"
          className="text-base text-gray-500 mb-8"
        >
          {t("notFound.message")}
        </p>
        <Link
          to="/dashboard"
          data-testid="not-found-home-link"
          className="btn btn-ghost"
        >
          {t("notFound.goToDashboard")}
        </Link>
      </div>
    </div>
  );
}
